import { NavLink } from 'react-router-dom';
import styles from './TopNav.module.css';

const LINKS: { to: string; label: string }[] = [
  { to: '/chat', label: 'Беседа' },
  { to: '/partners', label: 'Партнёры' },
  { to: '/onboarding', label: 'Онбординг' },
  { to: '/coach', label: 'Тренер' },
  { to: '/journal', label: 'Дневник' },
  { to: '/navigator', label: 'Навигатор' },
];

export function TopNav() {
  return (
    <header className={styles.bar}>
      <div className={styles.mark}>
        <em>Линза</em>
      </div>
      <nav className={styles.links}>
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) => (isActive ? `${styles.link} ${styles.active}` : styles.link)}
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
